<template>
    <div ref="appContainer" @dragenter="setHightlights" @dragover="setHightlights" 
        @dragend="unsetHighlights" @drop="unsetHighlights">
    <transition name="fade">
        <div class="spinnerContainer" v-show="showSpinner">
            <div class="spinner">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
        </div>
    </transition>
    <template v-if="showApp">
        <div class="appMode" v-if="appMode != 'production'">Modalità: {{appMode}}</div>
        <div class="d-flex" v-if="showMenu">
            <nav class="sideMenu d-flex flex-column p-3">
                <div class="fw-bold text-primary mb-4 px-2">Backoffice</div>
                <div class="navContainer flex-grow-1 gap-1">
                    <router-link v-for="item in menuItems" :key="item.path" :to="item.path"
                        class="sideNav text-decoration-none" :class="{ active: isActive(item.path) }">
                        <component :is="item.icon" class="me-2" v-if="item.icon" />
                        <span>{{ item.label }}</span>
                    </router-link>
                </div>
                <button class="btn btn-outline-secondary btn-sm" @click="logout">
                    <icon-box-arrow-right class="me-2" />
                    Esci
                </button>
            </nav>
            <main class="flex-grow-1" style="min-width: 0;">
                <router-view/>
            </main>
        </div>
        <router-view v-else/>
    </template>
    <op-modal-container></op-modal-container>
</div>
</template>

<script lang="ts">
import store from '@/store';
import { ModalServices } from '@/services/ModalServices'
import { LoginClient } from './services/Services';
import { Options, Vue } from 'vue-class-component';
import { mode } from './config';
import { CommonServices } from './services/CommonServices';

@Options({})
export default class App extends Vue {
    
    get showSpinner(){
        return store.state.showSpinner > 0;
    }
    get showMenu(){
        return this.$route.name != 'login';
    }
    showApp: boolean = false;
    appMode: string = "";
    
    created(){
        this.appMode = mode;
        
        ModalServices.setOpModal(this.$opModal);
    
        LoginClient.refreshLogin()
        .then(x => {
            CommonServices.setAuthToken(x);
        })
        .catch(err => {
            this.$router.replace("/");
        })
        .finally(() => {
            this.showApp = true;
        })
    }

    // voci = route con meta.sideMenuLabel e senza parametri (i dettagli restano fuori)
    get menuItems() {
        return this.$router.getRoutes()
            .filter(x => x.meta?.sideMenuLabel && !x.path.includes(':'))
            .map(x => ({
                path: x.path,
                label: x.meta.sideMenuLabel as string,
                icon: x.meta.sideMenuIcon as string
            }));
    }

    // attivo anche sulle pagine di dettaglio (es. /userActivations/xyz)
    isActive(path: string) {
        return this.$route.path == path || this.$route.path.startsWith(path + '/');
    }

    logout() {
        // prima si naviga: una pagina può annullare l'uscita (es. modifiche non salvate) e il token deve restare
        this.$router.push('/')
        .then(failure => {
            if(!failure)
                CommonServices.destroyToken();
        });
    }


    setHightlights(event){
        event.preventDefault();
        (this.$refs.appContainer as HTMLElement).classList.add('highlightDrags');
    }
    unsetHighlights(event){
        event.preventDefault();
        (this.$refs.appContainer as HTMLElement).classList.remove('highlightDrags');
    }
}

</script>
